export const scanFilesRecursively = async (item) => {
  let files = [];
  if (item.isFile) {
    const file = await new Promise((resolve) => item.file(resolve));
    if (file && file.type.startsWith("image/")) {
      files.push(file);
    }
  } else if (item.isDirectory) {
    const dirReader = item.createReader();
    const entries = await new Promise((resolve) => {
      const readAllEntries = (reader, accumulated = []) => {
        reader.readEntries((result) => {
          if (result.length === 0) {
            resolve(accumulated);
          } else {
            readAllEntries(reader, accumulated.concat(result));
          }
        }, () => resolve(accumulated));
      };
      readAllEntries(dirReader);
    });
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const subFiles = await scanFilesRecursively(entry);
      files.push(...subFiles);
      if (i % 100 === 0) await new Promise(r => setTimeout(r, 0));
    }
  }
  return files;
};
